/**
 * Популярные города для быстрого выбора
 */
export const POPULAR_CITIES = [
    { name: "Київ", ref: "e718a680-4b33-11e4-ab6d-005056801329" },
    { name: "Харків", ref: "e71f8842-4b33-11e4-ab6d-005056801329" },
    { name: "Одеса", ref: "e71c2a15-4b33-11e4-ab6d-005056801329" },
    { name: "Дніпро", ref: "e717110a-4b33-11e4-ab6d-005056801329" },
    { name: "Запоріжжя", ref: "e717bce9-4b33-11e4-ab6d-005056801329" },
    { name: "Львів", ref: "e71abb60-4b33-11e4-ab6d-005056801329" },
];
